<div class="flex flex-col gap-0.5">
  @if (isBookedExternally$ | async) {
    @if (bookedExternallyConfig$ | async; as config) {
      @if (config.enabled) {
        <div
          class="badge"
          [matTooltip]="externalBookingTooltip$ | async"
          [matTooltipDisabled]="!tooltipsEnabled()"
          [ngStyle]="{
            'background-color': config.backgroundColour,
            color: config.colour || white,
            width: badgeStyles().width,
            height: badgeStyles().height
          }"
        >
          @if (config.mode === statusIndicatorMode.Icon) {
            <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
          } @else {
            {{ config.character }}
          }
        </div>
      }
    }
  }

  @if (isOnlineBooking$ | async) {
    @if (onlineBookingConfig$ | async; as config) {
      @if (config.enabled) {
        <div
          class="badge"
          matTooltip="Online booking"
          [matTooltipDisabled]="!tooltipsEnabled()"
          [ngStyle]="{
            'background-color': config.backgroundColour,
            color: config.colour || white,
            width: badgeStyles().width,
            height: badgeStyles().height
          }"
        >
          @if (config.mode === statusIndicatorMode.Icon) {
            <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
          } @else {
            {{ config.character }}
          }
        </div>
      }
    }
  }

  @if (isNotConfirmed$ | async) {
    @if (notConfirmedConfig$ | async; as config) {
      @if (config.enabled) {
        <div
          class="badge"
          matTooltip="Appointment Not Confirmed"
          [matTooltipDisabled]="!tooltipsEnabled()"
          [ngStyle]="{
            'background-color': config.backgroundColour,
            color: config.colour || white,
            width: badgeStyles().width,
            height: badgeStyles().height
          }"
        >
          @if (config.mode === statusIndicatorMode.Icon) {
            <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
          } @else {
            {{ config.character }}
          }
        </div>
      }
    }
  }

  @if (hasArrived$ | async) {
    @if (hasArrivedConfig$ | async; as config) {
      @if (config.enabled) {
        <div
          class="badge"
          matTooltip="Patient Has Arrived"
          [matTooltipDisabled]="!tooltipsEnabled()"
          [ngStyle]="{
            'background-color': config.backgroundColour,
            color: config.colour || white,
            width: badgeStyles().width,
            height: badgeStyles().height
          }"
        >
          @if (config.mode === statusIndicatorMode.Icon) {
            <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
          } @else {
            {{ config.character }}
          }
        </div>
      }
    }
  }

  @if (appointmentStatusConfig$ | async; as config) {
    @if (config.enabled) {
      <div
        class="badge"
        [matTooltip]="
          (appointmentStatusTooltip$ | async) ?? '' | splitCamel | titlecase
        "
        [matTooltipDisabled]="!tooltipsEnabled()"
        [ngStyle]="{
          'background-color': config.backgroundColour,
          color: config.colour || white,
          width: badgeStyles().width,
          height: badgeStyles().height
        }"
      >
        @if (config.mode === statusIndicatorMode.Icon) {
          <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
        } @else {
          {{ config.character }}
        }
      </div>
    }
  }

  @if (showLabJobBadge$ | async) {
    @if (labJobBadgeState$ | async; as state) {
      @if (state === labJobBadgeState.Overdue) {
        @if (labJobOverdueConfig$ | async; as config) {
          @if (config.enabled) {
            <div
              class="badge"
              matTooltip="Lab Job Overdue"
              [matTooltipDisabled]="!tooltipsEnabled()"
              [ngStyle]="{
                'background-color': config.backgroundColour,
                color: config.colour || white,
                width: badgeStyles().width,
                height: badgeStyles().height
              }"
            >
              @if (config.mode === statusIndicatorMode.Icon) {
                <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
              } @else {
                {{ config.character }}
              }
            </div>
          }
        }
      }
      @if (state === labJobBadgeState.SentOrSending) {
        @if (labJobSentOrSendingConfig$ | async; as config) {
          @if (config.enabled) {
            <div
              class="badge"
              matTooltip="Lab Job Sent or Sending"
              [matTooltipDisabled]="!tooltipsEnabled()"
              [ngStyle]="{
                'background-color': config.backgroundColour,
                color: config.colour || white,
                width: badgeStyles().width,
                height: badgeStyles().height
              }"
            >
              @if (config.mode === statusIndicatorMode.Icon) {
                <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
              } @else {
                {{ config.character }}
              }
            </div>
          }
        }
      }
      @if (state === labJobBadgeState.Received) {
        @if (labJobReceivedConfig$ | async; as config) {
          @if (config.enabled) {
            <div
              class="badge"
              matTooltip="Lab Job Received"
              [matTooltipDisabled]="!tooltipsEnabled()"
              [ngStyle]="{
                'background-color': config.backgroundColour,
                color: config.colour || white,
                width: badgeStyles().width,
                height: badgeStyles().height
              }"
            >
              @if (config.mode === statusIndicatorMode.Icon) {
                <mat-icon [ngStyle]="iconStyles()">{{ config.icon }}</mat-icon>
              } @else {
                {{ config.character }}
              }
            </div>
          }
        }
      }
    }
  }
</div>
